import { ContentContainer, MediaQueryContainer } from "containers";
import { MainContainer, SidebarContainer } from "./components";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {getUserInfo} from "../../selectors/userInfo";
import {useEffect} from "react";
import {openModal, closeModal} from "../../layout";

const Cabinet = () => {

    const user = useSelector(getUserInfo, shallowEqual);
    const dispatch = useDispatch();

    const openModalLogin = () => {
        dispatch(openModal({ name: "AddDataCityModal" }));
    };

    useEffect(() => {
        // @ts-ignore
        if (user?.import_source && user?.group_id === null && user?.city_id === null) {
            // @ts-ignore
            if (user?.import_source?.alias === 'av_control') {
                openModalLogin()
            } else {
                dispatch(closeModal("AddDataCityModal"));
            }
        }  else {
            dispatch(closeModal("AddDataCityModal"));
        }
    }, [user, dispatch]);

  return (
    <ContentContainer>
      <MainContainer />
      <MediaQueryContainer minWidth={1245}>
        <SidebarContainer />
      </MediaQueryContainer>
    </ContentContainer>
  );
};

export default Cabinet;
